import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './components/pages/Home';
import Login from './components/auth/Login';
import AuthCallback from './components/auth/AuthCallback';
import PrivateRoute from './components/auth/PrivateRoute';
import Waitlist from './components/pages/Waitlist';
import RouteResults from './components/pages/RouteResults';
import AddToilet from './components/pages/AddToilet';
import Contact from './components/pages/Contact';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import Cookies from './components/pages/Cookies';
import About from './components/pages/About';
import { AuthProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <div className="container">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/waitlist" element={<Waitlist />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="/route-results"
                element={
                  <PrivateRoute>
                    <RouteResults />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-toilet"
                element={
                  <PrivateRoute>
                    <AddToilet />
                  </PrivateRoute>
                }
              />
              <Route
                path="/contact"
                element={<Contact />}
              />
            </Routes>
          </div>
          <Footer />
        </div>
        <Analytics />
      </Router>
    </AuthProvider>
  );
}

export default App; 